import { useMemo } from 'react';

import {
	AnswerReveal,
	PointsRow,
	StandardPatternBody,
} from '@quizzach/components';
import { IQuestion } from '@quizzach/interfaces';
import { analyzeStandardQuestion, patternAnswerHtml } from '@quizzach/utils';
import { QuestionText, QuestionContainer } from '@quizzach/play-styles';

interface IStandardQuestionProps {
	currentQuestionNumber: number;
	currentQuestion: IQuestion;
	color: string;
	totalQuestions: number;
}

interface IStandardQuestionAnswerProps {
	questionContainerColor: string;
	answerContainerColor: string;
	currentQuestionNumber: number;
	currentQuestion: IQuestion;
	totalQuestions: number;
	hideQuestion?: boolean;
}

export const StandardQuestionMobile = (props: IStandardQuestionProps) => {
	const { color, currentQuestion } = props;

	const analysis = useMemo(
		() => analyzeStandardQuestion(currentQuestion),
		[currentQuestion]
	);

	if (analysis.pattern || analysis.note || analysis.kicker) {
		return (
			<>
				<StandardPatternBody analysis={analysis} color={color} />
				<PointsRow
					points={currentQuestion.points}
					explanation={currentQuestion.points_explanation}
				/>
			</>
		);
	}

	return (
		<QuestionContainer color={color}>
			<QuestionText
				dangerouslySetInnerHTML={{
					__html: currentQuestion.standard_question!.question_hr,
				}}
			/>
			<PointsRow
				points={currentQuestion.points}
				explanation={currentQuestion.points_explanation}
			/>
		</QuestionContainer>
	);
};

export const StandardQuestionAnswerMobile = (
	props: IStandardQuestionAnswerProps
) => {
	const {
		questionContainerColor,
		currentQuestionNumber,
		currentQuestion,
		hideQuestion,
	} = props;

	const analysis = useMemo(
		() => analyzeStandardQuestion(currentQuestion),
		[currentQuestion]
	);

	return (
		<>
			{!hideQuestion &&
			(analysis.pattern || analysis.note || analysis.kicker) ? (
				<StandardPatternBody
					analysis={analysis}
					color={questionContainerColor}
					dim
				/>
			) : (
				<QuestionContainer color={questionContainerColor}>
					{!hideQuestion && (
						<QuestionText
							$small
							dangerouslySetInnerHTML={{
								__html: currentQuestion.standard_question!.question_hr,
							}}
						/>
					)}
				</QuestionContainer>
			)}
			<AnswerReveal
				revealKey={currentQuestionNumber}
				answerHtml={patternAnswerHtml(
					analysis.pattern,
					currentQuestion.standard_question?.answer_hr || ''
				)}
				explanation={currentQuestion.standard_question?.explanation_hr}
			/>
			<PointsRow
				points={currentQuestion.points}
				explanation={currentQuestion.points_explanation}
			/>
		</>
	);
};
